/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { APP_NAME } from "configs/AppConfig";
import { css } from "@emotion/react";
import {
  TEMPLATE,
  MEDIA_QUERIES,
  DARK_MODE,
  BORDER,
} from "constants/ThemeConstant";
import { useSelector } from "react-redux";
import SupportModal from "./SupportModal";
import { MessageOutlined } from "@ant-design/icons";

export default function Footer() {
  const currentTheme = useSelector((state) => state.theme.currentTheme);
  const [openSupportModal, setOpenSupportModal] = useState(false);

  return (
    <footer
      css={css`
        height: ${TEMPLATE.FOOTER_HEIGHT}px;
        display: flex;
        margin: 0 ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
        align-items: center;
        border-top: 1px solid
          ${currentTheme === "dark"
            ? DARK_MODE.BORDER_BASE_COLOR
            : BORDER.BASE_COLOR};
        justify-content: space-between;

        @media ${MEDIA_QUERIES.MOBILE} {
          justify-content: center;
          flex-direction: column;
        }
      `}
    >
      <span>
        Copyright {`${new Date().getFullYear()}`} &copy;{" "}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights
        reserved.
      </span>
      <span>
        Powered by{" "}
        <a href="https://www.pdex.ca/" target="_blank" rel="noreferrer">
          Poindexters Lab Inc.
        </a>
      </span>
      <div>
        <a
          className="text-gray"
          href={process.env.REACT_APP_ADMIN_URL}
          target="_blank"
          rel="noreferrer"
        >
          Admin
        </a>
        <span className="mx-2 text-muted">|</span>
        <a className="text-gray" href="/#" onClick={(e) => e.preventDefault()}>
          Terms
        </a>
        <span className="mx-2 text-muted">|</span>
        <a className="text-gray" href="/#" onClick={(e) => e.preventDefault()}>
          Privacy
        </a>
      </div>
      {((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl')) && <MessageOutlined
        style={{
          position: "fixed",
          right: "10px",
          bottom: "70px",
          fontSize: "35px",
          zIndex: "2",
          color: "#389e0d",
        }}
        onClick={() => setOpenSupportModal(!openSupportModal)}
      />}
      <SupportModal
        openSupportModal={openSupportModal}
        setOpenSupportModal={setOpenSupportModal}
      />
    </footer>
  );
}
